@if (isMaintenanceMode) {
  <main class="maintenance-page" [class.dark-mode]="isDarkMode">
    <section
      class="maintenance-card"
      [class.maintenance-card-dark]="isDarkMode"
    >
      <p class="maintenance-label" [class.maintenance-label-dark]="isDarkMode">
        Land IQ Irrigation Management
      </p>
      <h1 class="maintenance-title" [class.maintenance-title-dark]="isDarkMode">
        {{ maintenanceTitle }}
      </h1>
      <p
        class="maintenance-message"
        [class.maintenance-message-dark]="isDarkMode"
      >
        {{ maintenanceMessage }}
      </p>
      <p class="maintenance-eta" [class.maintenance-eta-dark]="isDarkMode">
        {{ maintenanceEta }}
      </p>
    </section>
  </main>
} @else {
  <router-outlet></router-outlet>
  <app-snackbar></app-snackbar>
  <app-spinner></app-spinner>
  <app-dialog></app-dialog>
}
